'use client'

import { useState } from 'react'

import { Arrow } from '@/components/icons'
import { Button } from '@/ui/button/Button'

type HelpMeChooseActionButtonProps = {
  children: React.ReactNode
  className?: string
  bgColor?: string
  hoveredBgColor?: string
  textColor?: string
  hoveredTextColor?: string
  onClick?: () => void
  hasArrowIcon?: boolean
}

const HelpMeChooseActionButton = ({
  children,
  className,
  bgColor = '#DA291C',
  hoveredBgColor = '#FFFFFF',
  textColor = '#FFFFFF',
  hoveredTextColor = '#DA291C',
  hasArrowIcon = true,
  onClick,
}: HelpMeChooseActionButtonProps) => {
  const [isHover, setIsHover] = useState(false)

  return (
    <Button
      onClick={onClick}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      className={className}
      style={{
        backgroundColor: isHover ? hoveredBgColor : bgColor,
        color: isHover ? hoveredTextColor : textColor,
      }}>
      <>
        {children}
        {hasArrowIcon && <Arrow width={16} height={16} color={isHover ? '#DA291C' : 'white'} />}
      </>
    </Button>
  )
}

export { HelpMeChooseActionButton }
